import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import insta from "./icons/instagram New.svg";
import face from "./icons/Facebook new.svg";
import twit from "./icons/Twitter.svg";
import closeIcon from "./icons/close (1).png";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
  EmailIcon,
} from "react-share";
import { useParams } from "react-router-dom";
import { fetchlogoSocial } from "./apiFolder/index";

function RssSocial() {
  const { id: school_id } = useParams();
  const [posts, setPosts] = useState([]);
  const [logo, setLogo] = useState({});
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [postIndex, setPostIndex] = useState(0);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isShare, setIsShare] = useState(false);
  const cardRef = useRef(null);

  // JSON feed URL from query param or default
  const feedUrl = new URLSearchParams(window.location.search).get("feed") ||
    "https://rss.app/feeds/_38qx7IeNkG4LJGFI.json";

  function parseJsonFeed(data) {
    const feedTitle = data.title || "";

    return (data.items || []).map((item, idx) => {
      // Image: extract from content_html if present
      let image = "";
      if (item.content_html) {
        const imgMatch = item.content_html.match(/<img[^>]+src="([^"]+)"/);
        if (imgMatch) image = imgMatch[1];
      }

      // Plain text description
      const description = item.content_text || "";

      // Creator
      const creator =
        (item.authors && item.authors[0]?.name) || feedTitle;

      // Detect source from URL
      const link = item.url || "";
      let source = "instagram";
      if (link.includes("facebook")) source = "facebook";
      else if (link.includes("twitter") || link.includes("x.com"))
        source = "twitter";

      return {
        id: item.id || `rss-${idx}`,
        title: item.title || "",
        description,
        media: image,
        creator,
        date: item.date_published || "",
        link,
        url: link,
        source,
      };
    });
  }

  useEffect(() => {
    axios
      .get(feedUrl)
      .then((res) => {
        const mapped = parseJsonFeed(res.data);
        setPosts(mapped);
        setLoading(false);
      })
      .catch((err) => {
        console.error("RSS fetch error:", err);
        setLoading(false);
      });

    // Fetch school logo if school_id is present
    if (school_id) {
      fetchlogoSocial(school_id)
        .then((res) => setLogo(res.data.body))
        .catch(() => {});
    }
  }, [feedUrl, school_id]);

  function getSourceIconUrl(source) {
    switch (source) {
      case "facebook":
        return face;
      case "instagram":
        return insta;
      case "twitter":
        return twit;
      default:
        return insta;
    }
  }

  function handleClick(index) {
    setPostIndex(index);
    setShowModal(true);
    setImageLoaded(false);
  }

  function closeModal() {
    setShowModal(false);
    setIsShare(false);
  }

  function handleClickNext() {
    if (postIndex < posts.length - 1) {
      setPostIndex(postIndex + 1);
      setImageLoaded(false);
    }
  }

  function handleClickPrev() {
    if (postIndex > 0) {
      setPostIndex(postIndex - 1);
      setImageLoaded(false);
    }
  }

  function handleClickOutside(e) {
    if (e.target.classList.contains("fullcard")) {
      closeModal();
    }
  }

  function extractText(str) {
    if (!str) return "";
    return str.replace(/<[^>]*>/g, "").trim();
  }

  function linkify(text) {
    if (!text) return "";
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);
    return parts.map((part, i) =>
      urlRegex.test(part) ? (
        <a key={i} href={part} target="_blank" rel="noopener noreferrer" style={{ color: "blue" }}>
          {part}
        </a>
      ) : (
        part
      )
    );
  }

  return (
    <div>
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <div className="w-10 h-10 border-4 border-t-4 loader-blue rounded-full animate-spin"></div>
        </div>
      ) : (
        <div
          className="py-6 px-4 sm:px-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5 mx-auto"
          style={{
            height: "95vh",
            overflowY: "scroll",
          }}
          ref={cardRef}
        >
          {posts &&
            posts.map((post, index) => (
              <React.Fragment key={post.id}>
                <article className="news-card PostShadow">
                  <div className="news-card__inner">
                    <div
                      className="news-card__media"
                      onClick={() => handleClick(index)}
                    >
                      {post.media ? (
                        <img
                          className="w-full h-full object-cover cursor-pointer"
                          src={post.media}
                          alt={post.title}
                          onError={(e) => {
                            e.target.src = logo.Full_Logo__c || "";
                          }}
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center bg-gray-100 cursor-pointer">
                          {logo.Full_Logo__c && (
                            <img
                              src={logo.Full_Logo__c}
                              alt="Logo"
                              style={{ maxHeight: "80px", objectFit: "contain" }}
                            />
                          )}
                        </div>
                      )}
                    </div>
                    <div className="news-card__body">
                      <div className="flex items-center gap-2 mb-2">
                        <img
                          src={getSourceIconUrl(post.source)}
                          alt="Source"
                          className="setimage feedsetimage"
                        />
                        <a
                          href={post.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="font-semibold text-sm hover:text-red-500"
                        >
                          {post.creator}
                        </a>
                      </div>
                      <time className="news-card__date">
                        {new Date(post.date).toLocaleDateString("en-US", {
                          month: "short",
                          day: "numeric",
                          year: "numeric",
                        })}
                      </time>
                      <h3
                        className="news-card__title cursor-pointer"
                        onClick={() => handleClick(index)}
                      >
                        {post.title}
                      </h3>
                      <p
                        className="news-card__excerpt cursor-pointer"
                        onClick={() => handleClick(index)}
                      >
                        {extractText(post.description)}
                      </p>
                      <footer className="news-card__footer">
                        <a
                          href={post.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="news-card__views"
                          style={{ textDecoration: "none" }}
                        >
                          View post
                        </a>
                        <div className="news-card__actions">
                          <div className="news-card__action-row">
                            <div className="news-card__action-btn">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (navigator.share) {
                                    navigator.share({
                                      title: post.title,
                                      url: post.link,
                                    });
                                  } else {
                                    navigator.clipboard.writeText(post.link);
                                  }
                                }}
                              >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                  <circle cx="18" cy="5" r="3" />
                                  <circle cx="6" cy="12" r="3" />
                                  <circle cx="18" cy="19" r="3" />
                                  <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                                  <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </footer>
                    </div>
                  </div>
                </article>

                {/* Modal */}
                {postIndex === index && showModal && (
                  <div
                    className="modal fullcard"
                    onClick={handleClickOutside}
                  >
                    <div className="prevbtn mr-12 sm:mr-1 md:mr-8">
                      <span
                        className="prev-arrow cursor-pointer prevbtn"
                        onClick={handleClickPrev}
                      >
                        &#10094;
                      </span>
                    </div>
                    <div className="modal-content modal-card modal-card-modern xl:w-3/5 lg:w-4/5 md:w-4/5 sm:w-4/5 relative">
                      <div className="modal-close-row">
                        <div className="Close-modal" onClick={closeModal}>
                          <img className="Close-image" src={closeIcon} alt="Close" />
                        </div>
                      </div>
                      <div className="modal-scroll-area">
                        {/* Header */}
                        <div className="modal-header-modern">
                          <div className="modal-header-top">
                            <img
                              src={getSourceIconUrl(post.source)}
                              alt="Source"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "10px",
                                objectFit: "contain",
                                border: "1px solid #e5e7eb",
                              }}
                            />
                            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                              <a
                                href={post.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="font-semibold hover:text-red-500"
                                style={{ fontSize: "14px", color: "#111827", textDecoration: "none" }}
                              >
                                {post.creator}
                              </a>
                              <time className="modal-date-modern">
                                {new Date(post.date)
                                  .toLocaleDateString("en-US", {
                                    month: "short",
                                    day: "numeric",
                                    year: "numeric",
                                  })
                                  .toUpperCase()}
                              </time>
                            </div>
                          </div>
                          {post.title && (
                            <h2 className="modal-title-modern">{post.title}</h2>
                          )}
                          <div className="modal-desc-modern">
                            {linkify(extractText(post.description))}
                          </div>
                        </div>

                        {/* Media */}
                        {post.media && (
                          <div style={{ padding: "12px 0" }}>
                            <div className="flex justify-center">
                              <div className="relative image-wrapper">
                                <img
                                  className="w-full object-contain post-image"
                                  src={post.media}
                                  onError={(e) => {
                                    e.target.src = logo.Full_Logo__c || "";
                                  }}
                                  alt={post.title}
                                  onLoad={() => setImageLoaded(true)}
                                  style={{
                                    display: imageLoaded ? "block" : "none",
                                    borderRadius: "12px",
                                    maxHeight: "500px",
                                  }}
                                />
                                {!imageLoaded && (
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "300px",
                                      background: "#f3f4f6",
                                      borderRadius: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#9ca3af",
                                    }}
                                  >
                                    Loading...
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Footer */}
                      <div className="modal-footer-modern">
                        <a
                          href={post.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="modal-views-modern"
                          style={{ textDecoration: "none" }}
                        >
                          View original post
                        </a>
                        <div className="modal-footer-actions">
                          <div className="news-card__action-btn" style={{ position: "relative" }}>
                            <button
                              onClick={() => setIsShare(!isShare)}
                            >
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="18" cy="5" r="3" />
                                <circle cx="6" cy="12" r="3" />
                                <circle cx="18" cy="19" r="3" />
                                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                              </svg>
                            </button>
                            {isShare && (
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: "100%",
                                  right: 0,
                                  background: "white",
                                  borderRadius: "12px",
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                  padding: "8px",
                                  display: "flex",
                                  gap: "6px",
                                  zIndex: 20,
                                  marginBottom: "8px",
                                }}
                              >
                                <FacebookShareButton url={post.link}>
                                  <FacebookIcon size={32} round />
                                </FacebookShareButton>
                                <TwitterShareButton url={post.link}>
                                  <TwitterIcon size={32} round />
                                </TwitterShareButton>
                                <WhatsappShareButton url={post.link}>
                                  <WhatsappIcon size={32} round />
                                </WhatsappShareButton>
                                <LinkedinShareButton url={post.link}>
                                  <LinkedinIcon size={32} round />
                                </LinkedinShareButton>
                                <EmailShareButton subject={post.title} url={post.link}>
                                  <EmailIcon size={32} round />
                                </EmailShareButton>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="nxtbtn ml-12 sm:ml-1 md:ml-8">
                      <span
                        className="next-arrow cursor-pointer nxtbtn"
                        onClick={handleClickNext}
                      >
                        &#10095;
                      </span>
                    </div>
                  </div>
                )}
              </React.Fragment>
            ))}
        </div>
      )}
    </div>
  );
}

export default RssSocial;
